import React from 'react';
import { useSidebar } from '../../Utility/SidebaarContext';

const Pagination = ({
  totalPages,
  currentPage,
  rowsPerPage,
  setRowsPerPage,
  setCurrentPage,
}) => {
  // Updated row options
  const rowOptions = [20, 50, 100];

  // Handle rows per page change
  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setCurrentPage(1); // Reset to first page when changing rows per page
  };

  // Navigate to different pages
  const goToFirstPage = () => setCurrentPage(1);
  const goToLastPage = () => setCurrentPage(totalPages);
  const goToPreviousPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
  const goToNextPage = () => setCurrentPage((prev) => Math.min(prev + 1, totalPages));

  // Generate page numbers
  const pageNumbers = [];
  if (totalPages <= 5) {
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(i);
    }
  } else {
    if (currentPage < 4) {
      pageNumbers.push(1, 2, 3, 4, '...', totalPages);
    } else if (currentPage > totalPages - 3) {
      pageNumbers.push(1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
    } else {
      pageNumbers.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
    }
  }
 const { isSidebarExpanded} =  useSidebar();
  return (
    <section className={`flex fixed bottom-0 max-md:w-full  ${isSidebarExpanded ? 'md:left-[21.438rem]':'md:left-[9.438rem]'}  md:right-[4rem] bg-DarkBlue justify-between py-1 px-10 border-t-2 border-gray-400 items-center space-x-2 mt-4`}>
      {/* Rows per page dropdown */}
      <div>
        <select value={rowsPerPage} onChange={handleRowsPerPageChange} className="p-1 bg-SoftBlack text-white">
          {rowOptions.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>

      {/* Pagination buttons */}
      <div className="gap-2 flex">
        {/* Previous Page Button */}
        <button
          onClick={goToPreviousPage}
          disabled={currentPage === 1}
          className={`px-3 py-1 rounded ${currentPage === 1 ? 'bg-gray-400' : 'bg-gray-600'} text-white`}
        >
          &lt;
        </button>

        {/* Page Numbers */}
        {pageNumbers.map((page, index) =>
          page === '...' ? (
            <span key={index} className="px-3 py-1 text-white">
              ...
            </span>
          ) : (
            <button
              key={index}
              onClick={() => setCurrentPage(page)}
              className={`px-3 py-1 rounded ${page === currentPage ? 'bg-red-500 text-white' : 'bg-gray-700 text-white'}`}
            >
              {page}
            </button>
          )
        )}

        {/* Next Page Button */}
        <button
          onClick={goToNextPage}
          disabled={currentPage === totalPages}
          className={`px-3 py-1 rounded ${currentPage === totalPages ? 'bg-gray-400' : 'bg-gray-600'} text-white`}
        >
          &gt;
        </button>
      </div>
    </section>
  );
};

export default Pagination;
